// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'name',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'name_en',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'image',
    label: '',
    width: '150',
    img: true
  }, {
    prop: 'updated_at',
    label: '',
    Object: 'value',
    width: '120'
  }]
}
